import { Fragment, useEffect, useRef } from "react";
import { ContactAndSchedule } from "./ContactAndSchedule";
import ContactForm from "./ContactForm";
import { UnderConstruction } from "./UnderConstruction";
import { ASSETS_URL } from "../utils/constants";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";


const liteblock4 = ASSETS_URL + 'project_liteblock-totalSolar-4.webp'
const liteblock5 = ASSETS_URL + 'project_liteblock-totalSolar-5.webp'

export const listOfUpdates = [
  {
    id: 1,
    date: 'May 26, 2024',
    title: 'Title 1',
    image: liteblock4,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque metus at mattis dignissim. Mauris vitae fermentum est, a ornare risus. Sed vel cursus neque, id aliquam leo. Morbi eget finibus purus, sit amet condimentum mauris. Morbi nec lacus ultrices, rhoncus arcu ut, dapibus arcu.',
    body: <>
      hello 1
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque metus at mattis dignissim. Mauris vitae fermentum est, a ornare risus. Sed vel cursus neque, id aliquam leo. Morbi eget finibus purus, sit amet condimentum mauris. Morbi nec lacus ultrices, rhoncus arcu ut, dapibus arcu.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque metus at mattis dignissim. Mauris vitae fermentum est, a ornare risus. Sed vel cursus neque, id aliquam leo. Morbi eget finibus purus, sit amet condimentum mauris. Morbi nec lacus ultrices, rhoncus arcu ut, dapibus arcu.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque metus at mattis dignissim. Mauris vitae fermentum est, a ornare risus. Sed vel cursus neque, id aliquam leo. Morbi eget finibus purus, sit amet condimentum mauris. Morbi nec lacus ultrices, rhoncus arcu ut, dapibus arcu.
    </>
  },
  {
    id: 2,
    date: 'May 27, 2024',
    title: 'Title 2',
    image: liteblock5,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque metus at mattis dignissim. Mauris vitae fermentum est, a ornare risus. Sed vel cursus neque, id aliquam leo. Morbi eget finibus purus, sit amet condimentum mauris. Morbi nec lacus ultrices, rhoncus arcu ut, dapibus arcu.',
    body: <>
      hello 2
    </>
  },
  {
    id: 1,
    date: 'May 26, 2024',
    title: 'Title 1',
    image: liteblock4,
    description: 'description 1',
    body: <>
      hello 1
    </>
  },
  {
    id: 2,
    date: 'May 27, 2024',
    title: 'Title 2',
    image: liteblock5,
    description: 'description 2',
    body: <>
      hello 2
    </>
  }
]

function Updates() {
    const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])

    
    return <>
      <div ref={containerRef} className="font-[Montserrat] w-[80%] min-h-[80vh] grid grid-cols-1 gap-2 md:grid-cols-3">
        {
          listOfUpdates.map((item) => <Fragment key={`update${item.id}`}>
            <div className="bg-white min-h-[400px] rounded-lg m-2 cursor-pointer flex flex-col">
              <img className="w-full h-[200px] rounded-t-lg" src={item.image} />
              <div className="text-left font-bold px-4 py-1">{item.title}</div>
              <div className="text-left text-xs px-4 mb-1 flex items-center italic"><CalendarDaysIcon className="h-3 w-3 mr-1"/>{item.date}</div>
              <div className="text-left text-xs px-4 mb-2 ">{item.description}</div>
              <Link to={''+item.id} type='button' className="text-[#f7f7f7] px-6 py-2 mt-auto ml-auto mr-3 mb-3 rounded-xl text-sm font-bold w-fit bg-[#212121] hover:bg-[#4CB117] hover:text-[#212121]"
                    >
                Read More
            </Link>
            </div>
          </Fragment>)
        }
      </div>
    </>
  }
  
  export default Updates;